module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.744961de.ttf";